import { render, staticRenderFns } from "./EditorRead.vue?vue&type=template&id=3bb2b5c4&"
import script from "./EditorRead.vue?vue&type=script&lang=js&"
export * from "./EditorRead.vue?vue&type=script&lang=js&"
import style0 from "./EditorRead.vue?vue&type=style&index=0&id=3bb2b5c4&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports